import { render, staticRenderFns } from "./UpdateWidget.vue?vue&type=template&id=0ec86066&scoped=true"
import script from "./UpdateWidget.vue?vue&type=script&lang=js"
export * from "./UpdateWidget.vue?vue&type=script&lang=js"
import style0 from "./UpdateWidget.vue?vue&type=style&index=0&id=0ec86066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec86066",
  null
  
)

export default component.exports